import React from 'react';
import ReactImageMagnify from 'react-image-magnify';

import {handleImageTypes} from '../../../../utils/carouselHelpers';
import LazyImage from '../../LazyImage/LazyImage';


interface CarouselSlideProps {
  index: number;
  imageSrcSmall: string;
  imageSrcLarge: string;
  imgAlt: string;
  imageHeight: string | number;
  imageWidth: string | number;
  children?: Record<string, unknown>;
  isProductPage: boolean;
  isMobile: boolean;
  zoomSize?: number;
}

const CarouselSlide = ({index, children, imageSrcSmall, imageSrcLarge, imgAlt, imageHeight, imageWidth, zoomSize, isProductPage, isMobile}: CarouselSlideProps): JSX.Element => {
  const renderImage = () => {
    const zoomImage = <ReactImageMagnify {...{
      enlargedImagePosition: 'over',
      className: 'fallback-image-wrapper',
      imageClassName: 'fallback-image small-carousel-image',
      enlargedImageClassName: 'large-carousel-image',
      isActivatedOnTouch: !isMobile,
      hoverDelayInMs: 250,
      isEnlargedImagePortalEnabledForTouch: true,
      smallImage: {
        alt: imgAlt,
        src: imageSrcSmall,
        isFluidWidth: false,
        width: handleImageTypes(imageWidth),
        height: handleImageTypes(imageHeight)
      },
      largeImage: {
        alt: imgAlt,
        src: imageSrcLarge,
        width: zoomSize || handleImageTypes(imageWidth) * 2,
        height: zoomSize || handleImageTypes(imageHeight) * 2
      }
    }}/>;
    const lazyImage = (
      <LazyImage
        alt={imgAlt}
        className='fallback-image'
        height={imageHeight}
        width={imageWidth}
        src={imageSrcSmall}
      />
    );

    if (isProductPage) {
      return (isMobile && index !== 0) ? lazyImage : zoomImage;
    }

    return lazyImage;
  };

  return (
    <React.Fragment>
      <picture className='carousel-image' itemProp='image'>
        {renderImage()}
      </picture>
      {children}
    </React.Fragment>
  );
};

export default CarouselSlide;
